module.exports = __webpack_public_path__ + "static/media/sports1.cbd900db.jpg";